/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react'

import { Navigate, Outlet } from 'react-router-dom'

const PublicRoute = (props: any) => {
  const token = localStorage.getItem('token') && localStorage.getItem('adminAccess') == 'true'

  return token ? <Navigate to='/invalid-solana-nfts' /> : <Outlet {...props} />
}

export default PublicRoute
